// extracted by mini-css-extract-plugin
module.exports = {"content":"ResourceList_content__z85pT","main":"ResourceList_main__3z3hH"};